// #if process.env.WEBPACK_ENV_TARGET === 'server'
// export default from 'url';
// #endif

// #if process.env.WEBPACK_ENV_TARGET === 'client'
import { parse as queryParse, stringify } from 'query-string';
const parse = (url: string) => {
  const elm = document.createElement('a');
  elm.href = url;
  const { origin, protocol, pathname, search, hash, host } = elm;
  return {
    host,
    origin,
    protocol,
    pathname,
    query: queryParse(search),
    hash,
  };
};
const format = ({
  host,
  protocol,
  pathname,
  query,
  hash = '',
}: {
  host: string,
  protocol: string,
  pathname: string,
  query: Object,
  hash?: string,
}) => `${protocol}//${host}${pathname}?${stringify(query)}${hash}`;
export default {
  parse,
  format,
};
// #endif